<template>
    <i class="far fa-question-circle xs help-popover" v-tooltipped:[tooltip]="true"></i>
</template>

<script>
import tooltipped from "@modules/JourneyBuilder/directives/tooltipped";

export default {
    props: {
        title: {
            type: String,
        },

        content: {
            type: String,
        }
    },

    directives: {
        tooltipped
    },

    computed: {
        tooltip() {
            return { title: this.title, content: this.content };
        }
    },
}
</script>

<style scoped>
    .help-popover {
        color: #007bff;
    }
</style>